import styled from 'styled-components';
import { key } from 'styled-theme';
import { media } from '@sizeid/commons/utils/styles';

export default styled.div<{ light: boolean }>`
  margin: 20px auto;
  padding: 0 14px 10px;
  background: white;
  border-radius: ${key('sizes.borderRadius')};

  ${media.moreThan('mdPlus')`
    display: none;
  `};
  > strong {
    display: block;
    font-size: 20px;
    line-height: 50px;
    margin-left: -14px;
    margin-right: -14px;
    border-top-right-radius: ${key('sizes.borderRadius')};
    border-top-left-radius: ${key('sizes.borderRadius')};
    background: ${props =>
      props.light
        ? props.theme.colors.SIDB.light[200]
        : props.theme.colors.SIDB.light[400]};
    color: ${props =>
      props.light ? props.theme.colors.black.default : 'white'};
  }

  table {
    td {
      padding: 10px;
      vertical-align: middle;
      line-height: 1.4;

      &:first-child {
        font-size: 14px;
        color: ${key('colors.black.light.400')};
        width: 100%;
        text-align: left;
        padding-left: 0;
      }

      &:last-child {
        color: ${key('colors.black.default')};
        text-align: center;
        font-size: 20px;
        white-space: nowrap;
      }
    }

    tr:last-child td:last-child {
      font-weight: bold;
    }

    tr + tr {
      td {
        border-top: 2px solid ${key('colors.SIDB.light.50')};
      }
    }
  }
`;
